// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5090":"a3214dd0575ebf3e","6291":"8b77e2da2a18e6f6"}[chunkId] + ".js";
};